<template>
    <div id="app" :class="{ dark: isDark }">
        <router-view />
    </div>
</template>

<script>
import '../theme/palette.css';
export default {
    name: 'App',
    computed: {
        isDark () {
            return this.$store.state.appSettings.isDark;
        }
    },
    methods: {
        setDark (value) {
            this.$store.commit('appSettings/setDark', value);
        },
        setLLM (value) {
            this.$store.commit('appSettings/setLLM', value);
        },
        toggleDark () {
            this.$store.commit('appSettings/toggleDark');
        },
        toggleDebug () {
            this.$store.commit('appSettings/toggleDebug');
        }
    },
    // 在应用初始化前使vuex获取存储在本地的数据
    beforeCreate () {
        this.$store.commit('account/retrieveInfo');
        this.$store.commit('appSettings/retrieveDark');
        this.$store.commit('appSettings/retrieveLLM');
        this.$store.commit('appSettings/retrieveDebug');
    }
};
</script>
<style lang="scss">
#app {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
}

.flex-center-hori {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
}

.flex-center-vert {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
}

// 思源黑体 Regular
@font-face {
    font-family: 'SourceHanSansSC-Regular';
    src: url('~@/assets/SourceHanSansSC-Regular.otf');
}
// 思源黑体 Medium
@font-face {
    font-family: 'SourceHanSansSC-Medium';
    src: url('~@/assets/SourceHanSansSC-Medium.otf');
}
</style>
